import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, Truck, HeartHandshake, Check } from "lucide-react";
import { SmartImage } from "@/components/SmartImage";
import { scrollToId } from "@/lib/scroll";

const CHIP_ICONS = [ShieldCheck, Truck, HeartHandshake, Check];

export const Hero = ({ hero = {}, config = {} }) => {
  const brand = config.brandName || "Ecentra";
  const badge = hero.badge && hero.badge.trim() ? hero.badge : `${brand} • ${config.location || "Pilipinas"}`;
  const chips = hero.chips || [];
  return (
    <section id="top" className="relative overflow-hidden grain">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_circle_at_15%_0%,hsl(168_45%_92%)_0%,transparent_55%),radial-gradient(900px_circle_at_90%_10%,hsl(24_70%_92%)_0%,transparent_50%)]" />
      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-28 sm:px-6 lg:grid-cols-12 lg:gap-8 lg:px-8 lg:pb-28 lg:pt-36">
        <div className="lg:col-span-6">
          <span className="inline-flex items-center rounded-full border border-border bg-card px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
            {badge}
          </span>
          <h1 className="font-display mt-5 text-4xl font-semibold leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            {hero.headline}
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {hero.subhead}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button size="lg" className="h-12 px-7 text-base" onClick={() => scrollToId("products")} data-testid="hero-shop-products-button">
              {hero.ctaShop || "Mag-shop Na"}
              <ArrowRight className="ml-1 h-5 w-5" />
            </Button>
            <Button size="lg" className="h-12 bg-accent px-7 text-base text-accent-foreground hover:bg-accent/90" onClick={() => scrollToId("join")} data-testid="hero-join-team-button">
              {hero.ctaJoin || "Join My Team"}
            </Button>
          </div>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {chips.map((c, i) => {
              const Icon = CHIP_ICONS[i] || Check;
              return (
                <div key={c.label || i} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Icon className="h-4 w-4 text-primary" />
                  {c.label}
                </div>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative mx-auto max-w-md lg:ml-auto lg:mr-0">
            <div className="overflow-hidden rounded-2xl border border-border bg-muted shadow-[0_18px_50px_-26px_rgba(15,23,42,0.4)]">
              <div className="aspect-[4/5]">
                <SmartImage src={hero.imageMain} alt="Ecentra products" fallbackLabel="Ecentra Wellness" />
              </div>
            </div>
            {hero.imageSecondary ? (
              <div className="absolute -bottom-8 -left-6 hidden w-40 overflow-hidden rounded-2xl border border-border bg-muted shadow-[0_18px_50px_-26px_rgba(15,23,42,0.45)] ring-1 ring-border sm:block">
                <div className="aspect-square">
                  <SmartImage src={hero.imageSecondary} alt="Ecentra detail" fallbackLabel="Beauty" />
                </div>
              </div>
            ) : null}
            <div className="absolute -right-3 top-6 hidden rounded-xl border border-border bg-card px-4 py-3 shadow-lg sm:block">
              <p className="font-display text-2xl font-semibold text-primary">{hero.statValue || "16+"}</p>
              <p className="text-xs text-muted-foreground">{hero.statLabel || "premium products"}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
